import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "..";
import { IBaseResponse, IListItem, IMedicalRecord, IPatientIntakeListItem } from '@nkr/models/index';
import { PassAutomatedProfiles } from '@nkr/enums/index';
import { IMedicalRecordResponse } from '@nkr/models/patient-intake/medical-record';

export interface IPatientIntakeListResponse {
    data: {
        success: boolean,
        results: IPatientIntakeListItem[]
    }
}

export interface IPatientIntakeListReplacementResponse {
    data: {
        success: boolean,
        results: IPatientIntakeListItem
    }
}

export interface IPatientIntakeResponse {
    data: {
        success: boolean,
        results: IMedicalRecordResponse
    }
}

export interface IPatientIntakeLookupDataResponse {
    data: {
        success: boolean,
        results: {
            coordinatorList: IListItem[],
            referralStatusList: IListItem[],
            sourceList: string[],
            centerList: IListItem[],
            declineReasonList: IListItem[],
            ethnicityList: IListItem[],
            maritalStatusList: IListItem[],
            employmentStatusList: IListItem[],
            educationLevelList: IListItem[],
            stateList: IListItem[],
            primaryGoalList: IListItem[],
            registrationStatusList: IListItem[]
        }
    }
}

export interface IUpdateWorkflowDetailsRequest {
    centerId: number;
    coordinatorId: number;
    followUpDate: string;
    status: number;
    firstName: string;
    lastName: string;
    preferredName: string;
    email: string;
    phoneNumber: string;
    phoneNumberSecondary: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    addressIsUs: boolean;
    genderId: number;
    preferredLanguageId: number;
    birthDate: string;
    statusChangeCenterId: number;
    transferCenterId: number;
    declineReason: number | null;
    declineReasonOther: string;
}

export interface IPassMicrositeRecipientProfile {
    type: PassAutomatedProfiles
    shortCode: string,
    mrn: string,
    abo: number,
    alias: string,
    tissueTyping: number,
    micrositeType: number,
    coordinator: number,
    language: number,
}

export interface IListRequest {
    centerId?: number,
    firstName?: string,
    lastName?: string,
    email?: string,
    source?: string,
    birthDate?: string,
    registrationDateFrom?: string,
    registrationDateTo?: string,
    listType: number,
    missingRecipientProfiles?: boolean,
    medicalRecordId?: number
    registrationStatus?: number,
    referralStatus?: number,
    primaryGoal?: number
}

export const ActionCreators = {
    getPatientIntakeList: (isAdmin: boolean, request: IListRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IPatientIntakeListResponse> => {
        let url = isAdmin
            ? `/admin/patient-intake/list`
            : `/recipient/patient-intake/list`;

        // if (medicalRecordId != null) {
        //     url = url + `&medicalRecordId=${medicalRecordId}`
        // }

        let options = {
            url: `${__API__}${url}`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getPatientIntakeListReplacement: (patientScreenId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IPatientIntakeListReplacementResponse> => {
        let url = `/recipient/patient-intake/list-replacement?patientScreenId=${patientScreenId}`;

        let options = {
            url: `${__API__}${url}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getPatientIntake: (medicalRecordId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IPatientIntakeResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/record?medicalRecordId=${medicalRecordId}&centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getPatientIntakeLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IPatientIntakeLookupDataResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/lookup-data?centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    updateWorkflowDetails: (patientScreenId: number, isAdmin: boolean, data: IUpdateWorkflowDetailsRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/update-workflow-details?patientScreenId=${patientScreenId}&isAdmin=${isAdmin}`,
            data: {
                ...data
            }
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },
    updateMedicalRecord: (medicalRecordId: number, isAdmin: boolean, data: IUpdateWorkflowDetailsRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/update-medical-record?medicalRecordId=${medicalRecordId}&isAdmin=${isAdmin}`,
            data: {
                ...data
            }
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },
    sendResetPasswordEmail: (medicalRecordId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/${medicalRecordId}/forgot-password`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    createMicrositeOrRecipient: (patientScreenId: number, workflowDetails: IUpdateWorkflowDetailsRequest, profileData: IPassMicrositeRecipientProfile) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/recipient/patient-intake/${patientScreenId}/automated-profile-creation`,
            data: {
                profileData: profileData,
                workflowDetails: workflowDetails
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    }
}